// extracted by mini-css-extract-plugin
export default {"root":"search-input_root__6W6ev","icon-root":"search-input_icon-root__m4hnp","input":"search-input_input__XRBlL"};